import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// Страница 403 для обычных user-аккаунтов Майнкрафтии.
// Появляется, если пользователь правильно зашёл по email/паролю, но не
// является ни владельцем центра (Owners), ни учителем (accessId/
// MyPrepodAndAdmin), ни глобальным админом.
//
// Это не страница ошибки сервера — это явный отказ в доступе с
// объяснением, куда идти дальше.

const NoAccess = () => {
  const navigate = useNavigate();
  const { profile, accessReason, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'linear-gradient(135deg, #0f172a, #1e293b)',
      padding: '24px',
      color: '#e2e8f0',
      fontFamily: 'system-ui, sans-serif',
    }}>
      <div style={{
        maxWidth: 520,
        width: '100%',
        background: '#111827',
        border: '1px solid #1f2937',
        borderRadius: 18,
        padding: '40px 36px',
        boxShadow: '0 30px 60px rgba(0,0,0,0.4)',
        textAlign: 'center',
      }}>
        <div style={{
          fontSize: 13,
          fontWeight: 700,
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          color: '#f59e0b',
          marginBottom: 14,
        }}>
          Доступ ограничен
        </div>

        <h1 style={{
          fontSize: 26,
          fontWeight: 800,
          letterSpacing: '-0.02em',
          color: '#fff',
          margin: '0 0 14px',
        }}>
          У вашего аккаунта нет доступа<br/>к админ-панели
        </h1>

        <p style={{
          color: '#94a3b8',
          fontSize: 15,
          lineHeight: 1.6,
          margin: '0 0 24px',
        }}>
          {accessReason ||
            'Эта панель предназначена только для владельцев и преподавателей детских образовательных центров.'}
        </p>

        {profile?.email && (
          <p style={{
            color: '#64748b',
            fontSize: 13,
            margin: '0 0 24px',
          }}>
            Вы вошли как: <span style={{ color: '#cbd5e1' }}>{profile.email}</span>
          </p>
        )}

        <div style={{
          background: 'rgba(59, 130, 246, 0.08)',
          border: '1px solid rgba(59, 130, 246, 0.25)',
          borderRadius: 12,
          padding: '14px 18px',
          textAlign: 'left',
          fontSize: 14,
          color: '#bfdbfe',
          lineHeight: 1.5,
          marginBottom: 24,
        }}>
          <b style={{ color: '#fff' }}>Хотите открыть свой центр?</b><br/>
          Подключите программу через <a
            href="https://startklass.ru"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#67e8f9', textDecoration: 'none', fontWeight: 600 }}
          >startklass.ru</a> — там есть бесплатное демо.
        </div>

        <button
          onClick={handleLogout}
          style={{
            width: '100%',
            padding: '12px 18px',
            borderRadius: 10,
            border: 'none',
            background: 'linear-gradient(135deg, #3b82f6, #a855f7)',
            color: '#fff',
            fontSize: 15,
            fontWeight: 700,
            cursor: 'pointer',
            fontFamily: 'inherit',
          }}
        >
          Выйти и войти под другим аккаунтом
        </button>
      </div>
    </div>
  );
};

export default NoAccess;
